export const SET_PARTNER_SMS_CONFIG = 'SET_PARTNER_SMS_CONFIG';
